var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32ZM23.414 13.414C23.7783 13.0368 23.9799 12.5316 23.9753 12.0072C23.9708 11.4828 23.7605 10.9812 23.3896 10.6104C23.0188 10.2395 22.5172 10.0292 21.9928 10.0247C21.4684 10.0201 20.9632 10.2217 20.586 10.586L14 17.172L11.414 14.586C11.0368 14.2217 10.5316 14.0201 10.0072 14.0247C9.4828 14.0292 8.98118 14.2395 8.61036 14.6104C8.23955 14.9812 8.02921 15.4828 8.02465 16.0072C8.02009 16.5316 8.22168 17.0368 8.586 17.414L12.586 21.414C12.9611 21.7889 13.4697 21.9996 14 21.9996C14.5303 21.9996 15.0389 21.7889 15.414 21.414L23.414 13.414Z",
    fill: "#389E0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.5c0ea994b9227542f1ce8c1b47bdd849.svg";
export { ForwardRef as ReactComponent };